import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import { masterApi } from "functions/apis";

const useStyles = makeStyles(styles);

const defaultValue = {
  code: "",
  name: ""
};

export function CreateSector(props) {
  const classes = useStyles();

  const createSectorSignal = React.useRef(new AbortController());

  const [payload, setPayload] = useState(defaultValue);
  const [disabled, setDisabled] = useState(false);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    return () => createSectorSignal.current.abort();
  }, []);

  const handleCodeChanged = e =>
    setPayload({ ...payload, code: e.target.value ?? "" });

  const handleNameChanged = e =>
    setPayload({ ...payload, name: e.target.value ?? "" });

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);

    masterApi
      .post("Sectors", payload, {
        signal: createSectorSignal.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/Sector/InDraft"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>CREATE SECTOR</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <form onSubmit={handleSubmit}>
              <GridContainer>
                <GridItem xs={6}>
                  <CustomInput
                    labelText="Code"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: handleCodeChanged,
                      value: payload.code ?? "",
                      inputProps: { maxLength: 80 }
                    }}
                  />
                </GridItem>
                <GridItem xs={6}>
                  <CustomInput
                    labelText="Name"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: handleNameChanged,
                      value: payload.name ?? "",
                      inputProps: { maxLength: 255 }
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={12}>
                  <Button
                    disabled={disabled}
                    color="rose"
                    type="submit"
                    value="Submit"
                  >
                    Submit
                  </Button>
                </GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

CreateSector.propTypes = {
  history: PropTypes.object
};
